import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSetServerStatus } from 'spectacle-ui-game-bridge-react';

export default function StatusTest() {
  // for now hard-code the path, later will change to use gamebridge function for grabbing url
  const preLoginJsonPath = 'https://telescope.callofduty.com/ts-mobile/mgl/tos/d357de0332d0ecb61e2d8577cc26b3d6352c1e31d47818bfa0b95bbf904ab88a/test/data/pre-login-test-status-retry.json';

  const setServerStatus = useSetServerStatus();
  const [btnIsDisabled, setBtnIsDisabled] = useState(false);
  const [checkedStatus, setCheckedStatus] = useState(1); //1 = server is down
  const [hasError, setHasError] = useState(false);

  const timeOutVal = 3000; //for disabling the button
  const defaultServerMsg = `We are still waiting in the pre-game lobby, meaning our servers are currently offline as we prepare to launch.\nWe appreciate the enthusiasm, but please return later after our servers are open on 11/30 17:00 UTC`;
  const checkingServerMsg = 'Checking Server Status...';
  const defaultErrorMsg = 'An unexpected error has occurred, please try again later.';
  const [serverStatusMsg, setServerStatusMsg] = useState(defaultServerMsg);

  useEffect(() => {
    console.log('new checkedStatus: ', checkedStatus);
    if (checkedStatus === 0) {
      setServerStatus();
      console.log('setServerStatusOk');
    }
  }, [checkedStatus, setServerStatus]);

  const setErrorMsg = (err: string) => {
    setHasError(true);
    console.error('Error:', err);
  };

  const getServerStatus = () => {
    setHasError(false);
    fetch(preLoginJsonPath, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((res) => res.json())
      .then((json) => json.Status)
      .then(setCheckedStatus)
      .catch((err) => setErrorMsg(err));
  };

  const updateMsgDisplay = () => {
    const newMsg = hasError ? defaultErrorMsg : defaultServerMsg;
    setServerStatusMsg(newMsg);
  };

  const handleButtonTap = () => {
    setBtnIsDisabled(true);
    setServerStatusMsg(checkingServerMsg);
    setTimeout(() => {
      setBtnIsDisabled(false);
      updateMsgDisplay();
    }, timeOutVal);
  };

  const checkServerStatus = () => {
    handleButtonTap();
    getServerStatus();
  };

  return (
    <>
      <Helmet>
        <title>Server Status</title>
        <meta name="description" content="server status" />
      </Helmet>
      <div className="container">
        <h1>Server Status</h1>
        <p className="preline">{serverStatusMsg}</p>
        <button onClick={checkServerStatus} disabled={btnIsDisabled}>
          CHECK STATUS
        </button>
      </div>
    </>
  );
}
